// extracted by mini-css-extract-plugin
module.exports = {"SecurityLeftSide":"_3RDapXHJU5dtC4vi2OFxYE","SecurityRightSide":"D8lu_B8l6fxY6ueQzY-Xh"};